import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CGUID, SyncSeekUrl, SyncPullSerializedUrl,GetDatasyncMediaOneBlockSynchronously,SyncDeleteSynchronously} from "datasync-core";
import { globals} from "../Components/Globals/Globals";
import { produce } from 'immer';
const initialState = {
  videosItems: [],
  videoCount: 0,
  loadVideos_result:{status: 'idle', error: null},
  deleteVideo_result:{status: 'idle', error: null},
}

// Create an async thunk for loading videos
export const loadVideos = createAsyncThunk(
  'videos/loadVideos',
  async (thunkAPI) => {
    try {
      const response = await GetDatasyncMediaOneBlockSynchronously({
        session_guid: CGUID(),
        date_synchro: '1970-07-10 063050',
        company_guid: globals.datasync.platform_company_guid,
        datasync_url: globals.datasync_service.url,
        syncSeekUrl: SyncSeekUrl(globals.datasync_service.url),
        SyncPullSerializedGETurl: SyncPullSerializedUrl(globals.datasync_service.url),
        seek_filter_clause: ` true `, // Do not filter videos
        table_guid: globals.datasync.pf_videos_table_guid,
        debugging: true
      });
      if (globals.parameters.debugging)
        console.log("loadVideos::videos response = ",response)
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Create an async thunk for deleting videos
export const deleteVideo = createAsyncThunk(
  'videos/deleteVideo',
  async (deletedVideoObject) => {
    try {
      console.clear()
      console.log("deletedVideoObject->", deletedVideoObject)
      //Delete video from Remote Datasync Database
      const response = await SyncDeleteSynchronously({
        datasync_url:globals.datasync_service.url,
        data_guid: deletedVideoObject.data_guid});
      
      if (globals.parameters.debugging)
        console.log("deleteVideo->response = ",response)

      if (response.err || response.deleted_data_count !=1)
        throw(response.err)

      return response;
    } catch (error) {
      return deletedVideoObject.rejectWithValue(error.message);
    }
  }
);

const videoSlice = createSlice({
  name: 'videos',
  initialState,
  reducers: {
    addVideo(state, action) {
      // New stat added 
      try {
        if (globals.parameters.debugging){
          console.log("addVideo: ", state.videosItems)
          console.log("addVideo: ", state.videoCount)
          console.log("addVideo::action ->", action)  
        }
  
        state.videoCount++;
        state.videosItems.push(action.payload);
      } catch (error) {
        console.error("Video added but state list insertion fails !")
        alert("Echec de l'insertion du nouvel utilisateur en mémoire interne")
      }
    },

    updateVideo(state, action) {
      return produce(state, draft => {
        //Find former stat object to update
        const updatedVideoObject = draft.videosItems.find((video) => video.data_guid === action.payload.data_guid)
        console.log("updateVideo: updatedVideoObject->", updatedVideoObject)
        if (updatedVideoObject) {
          //update video in the array
          updatedVideoObject.data_blob.data_tier = action.payload.data_blob.data_tier;
        } else {
          console.error("updateVideo: Video not found in the array");
        }
      })
    },

    revertAllVideos(state){
      console.log("videoSlice revertAllVideos");
      state.videosItems = [];
      state.videoCount = 0;
      state.loadVideos_result = {status: 'idle', error: null};
      state.deleteVideo_result = {status: 'idle', error: null};
    },

    revertStatusVideo(state){
      if (globals.parameters.debugging)
        console.log("videoSlice revertStatusVideo")

      state.deleteVideo_result = {status: 'idle', error: null};
    }
  },
  extraReducers: (builder) => {
    builder
      /* loadVideos */
      .addCase(loadVideos.pending, (state, action) => {
        state.loadVideos_result = {status : "loading",error : null};
      })
      .addCase(loadVideos.fulfilled, (state, action) => {
        if (action.payload.length > 0) {
          state.loadVideos_result = {status : "succeeded",error : null};
          state.videosItems = action.payload;
          state.videoCount= action.payload.length;
        }
        else {
          state.loadVideos_result = {status : "succeeded",error : "No videos found !!!"};
          state.videosItems = [];
          state.videoCount= 0;
        }
      })
      .addCase(loadVideos.rejected, (state, action) => {
        state.loadVideos_result = {status : "failed",error : action.payload};
      })

      /* deleteVideo */
      .addCase(deleteVideo.pending, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteVideo.pending")
        console.log("deleteVideo.pending -> action", action)
        state.deleteVideo_result = {status : "deleting",error : null};
      })
      .addCase(deleteVideo.fulfilled, (state,action) => {
        //Video sucessfully deleted from syncDeleteAsynchronous process
        if (globals.parameters.redux_debugging) alert("deleteVideo.fulfilled")
          console.log("deleteVideo.fulfilled -> action", action, " state->", state)

        return produce(state, draft => {
          //Delete video from local state
          draft.videosItems = draft.videosItems.filter((video, j) => video.data_guid !== action.payload.data_guid)
          draft.videoCount--;

          draft.deleteVideo_result = {status : "deleted",error : null};
        })
      })
      .addCase(deleteVideo.rejected, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteVideo.rejected")
          console.log("deleteVideo.rejected -> action", action)
        state.deleteVideo_result = {status : "failed",error : action.payload};
      })
  },
});

export const { addVideo, updateVideo, revertAllVideos, revertStatusVideo } = videoSlice.actions;
export default videoSlice.reducer;